<div #content class="h-100">
  <div class="card h-100 mb-3">
    <div class="card-header pdf-exclude">
      <div class="col-12">
        <!-- Header Row: Report View and Icons -->
        <div class="row">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <h6 class="m-0 me-2">{{ "REPORTS.view.title" | translate }}</h6>
                <div class="d-flex align-items-center">
                  <button
                    mat-icon-button
                    class="pdf-icon icon-clean"
                    style="height: auto !important"
                    color="primary"
                    (click)="exportPDFData()"
                    [matTooltip]="'ALLREMAININGS.DOWNLOAD_REPORT' | translate"
                    matTooltipPosition="above"
                    aria-label="'REPORTS.view.filter.buttons.report-download' | translate"
                  >
                    <mat-icon class="icon-compact ms-2"
                      >picture_as_pdf</mat-icon
                    >
                  </button>
                </div>
              </div>
              <button
                mat-stroked-button
                class="d-flex align-items-center justify-content-between"
                color="primary"
                (click)="toggleSearchInputs()"
                [matTooltip]="'REPORTS.view.filter.tooltip' | translate"
                matTooltipPosition="above"
                aria-label="Toggle filters"
              >
                <mat-icon>tune</mat-icon>
                <span>{{ "REPORTS.view.filter.title" | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="" *ngIf="showSearchInputs">
        <div class="row align-items-center compact-inputs dropdown-pd-none">
          <!-- Field Dropdown -->
          <div class="col-xl-6 col-md-4 col-sm-6 col-12 mb-2">
            <div class="d-flex justify-content-start align-items-center">
              <div class="ms-1 flex-grow-1">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{
                    "REPORTS.view.filter.field.placeholder" | translate
                  }}</mat-label>
                  <mat-select
                    [(ngModel)]="searchView['field']"
                    (selectionChange)="onFieldLabelSelected($event.value)"
                  >
                    <!-- This shows only the label in selected display -->
                    <mat-select-trigger>
                      {{ searchView["field"] }}
                    </mat-select-trigger>

                    <mat-option value="undefined" disabled>
                      {{ "REPORTS.view.filter.field.placeholder" | translate }}
                    </mat-option>
                    <mat-option
                      *ngFor="let e of filterAttributes"
                      [value]="e.label"
                    >
                      <div class="d-flex align-items-center">
                        <span
                          class="badge me-2 fw-light"
                          [ngClass]="getButtonClass(e['type'])"
                        >
                          {{ getButtonLabels(e["type"]) }}
                        </span>
                        <span class="text-truncate" [title]="e['label']">
                          {{ e["label"] }}
                        </span>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <button
                mat-icon-button
                matTooltip="{{ 'REPORTS.view.filter.infoTooltip' | translate }}"
                matTooltipPosition="above"
                class="icon-center icon-clean"
                aria-label="Field information"
              >
                <mat-icon class="text-secondary icon-compact">info</mat-icon>
              </button>
            </div>
          </div>

          <!-- Condition Select -->
          <div class="col-xl-6 col-md-4 col-sm-6 col-12 mb-2">
            <div class="d-flex justify-content-start align-items-center">
              <div class="ms-1 flex-grow-1">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{
                    "REPORTS.view.filter.condition.placeholder" | translate
                  }}</mat-label>
                  <mat-select
                    [(ngModel)]="searchData['condition']"
                    id="condition"
                    name="condition"
                  >
                    <mat-option value="undefined" disabled>
                      {{
                        "REPORTS.view.filter.condition.placeholder" | translate
                      }}
                    </mat-option>
                    <mat-option
                      *ngFor="let e of operators"
                      [value]="e['value']"
                    >
                      {{ e["label"] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <button
                mat-icon-button
                matTooltip="{{ 'REPORTS.view.filter.infoTooltip' | translate }}"
                matTooltipPosition="above"
                class="icon-center icon-clean"
                aria-label="Condition information"
              >
                <mat-icon class="text-secondary icon-compact">info</mat-icon>
              </button>
            </div>
          </div>

          <!-- Value Input -->
          <div class="col-lg-auto col-md-12">
            <div
              class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-1"
            >
              <div class="d-flex flex-sm-nowrap align-items-center">
                <ng-container
                  *ngIf="
                    !['NULL', 'NOT NULL', 'EMPTY'].includes(
                      searchData['condition']
                    )
                  "
                >
                  <!-- Custom Day Dropdown -->
                  <div
                    class="custom-dropdown-wrapper flex-shrink-0"
                    *ngIf="
                      searchData['condition'] === 'DAY' &&
                      selectedSearchAtt === 'date'
                    "
                    style="min-width: 90px"
                  >
                    <div
                      class="custom-dropdown"
                      (click)="toggleDayDropdown(); $event.stopPropagation()"
                    >
                      <span>{{ selectedDay || "Day" }}</span>
                      <i class="fa fa-chevron-down"></i>
                    </div>
                    <ul *ngIf="dayDropdownOpen" class="dropdown-list">
                      <li
                        *ngFor="let day of days; let i = index"
                        [class.sticky-first-item]="i === 0"
                        (click)="selectDay(day); $event.stopPropagation()"
                      >
                        {{ day }}
                        <div *ngIf="i === 0" class="dropdown-separator"></div>
                      </li>
                    </ul>
                  </div>

                  <!-- Custom Month Dropdown -->
                  <div
                    class="custom-dropdown-wrapper flex-shrink-0"
                    *ngIf="
                      searchData['condition'] === 'MONTH' &&
                      selectedSearchAtt === 'date'
                    "
                    style="min-width: 90px"
                  >
                    <div
                      class="custom-dropdown"
                      (click)="toggleMonthDropdown(); $event.stopPropagation()"
                    >
                      <span>{{ getMonthName(selectedMonth) || "Month" }}</span>
                      <i class="fa fa-chevron-down"></i>
                    </div>
                    <ul *ngIf="monthDropdownOpen" class="dropdown-list">
                      <li
                        *ngFor="let month of months; let i = index"
                        [class.sticky-first-item]="i === 0"
                        (click)="selectMonth(month); $event.stopPropagation()"
                      >
                        {{ month.name }}
                        <div *ngIf="i === 0" class="dropdown-separator"></div>
                      </li>
                    </ul>
                  </div>

                  <!-- Day + Month Combined -->
                  <div
                    *ngIf="
                      searchData['condition'] === 'DAY_AND_MONTH' &&
                      selectedSearchAtt === 'date'
                    "
                    class="d-flex gap-1 flex-shrink-0"
                  >
                    <div
                      class="custom-dropdown-wrapper"
                      style="min-width: 70px"
                    >
                      <div
                        class="custom-dropdown custom-dropdown_dm"
                        (click)="toggleDayDropdown(); $event.stopPropagation()"
                      >
                        <span>{{ selectedDay || "D" }}</span>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                      <ul *ngIf="dayDropdownOpen" class="dropdown-list">
                        <li
                          *ngFor="let day of days; let i = index"
                          [class.sticky-first-item]="i === 0"
                          (click)="
                            selectDayForDayMonth(day); $event.stopPropagation()
                          "
                        >
                          {{ day }}
                          <div *ngIf="i === 0" class="dropdown-separator"></div>
                        </li>
                      </ul>
                    </div>

                    <div
                      class="custom-dropdown-wrapper"
                      style="min-width: 70px"
                    >
                      <div
                        class="custom-dropdown custom-dropdown_dm"
                        (click)="
                          toggleMonthDropdown(); $event.stopPropagation()
                        "
                      >
                        <span>{{ getMonthName(selectedMonth) || "M" }}</span>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                      <ul *ngIf="monthDropdownOpen" class="dropdown-list">
                        <li
                          *ngFor="let month of months; let i = index"
                          [class.sticky-first-item]="i === 0"
                          (click)="
                            selectMonthForDayMonth(month);
                            $event.stopPropagation()
                          "
                        >
                          {{ month.name }}
                          <div *ngIf="i === 0" class="dropdown-separator"></div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <ng-container *ngIf="searchData['condition'] !== 'BETWEEN'">
                <!-- Text input for non-numeric types -->
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      *ngIf="
                        selectedSearchAtt != 'number' &&
                        selectedSearchAtt != 'expression' &&
                        selectedSearchAtt != 'long' &&
                        selectedSearchAtt != 'date'
                      "
                    >
                      <mat-label>{{
                        "REPORTS.view.filter.value.textPlaceholder" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="searchData['value']"
                        name="value"
                        id="value"
                        type="text"
                      />
                </mat-form-field>

                <!-- Number input -->
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      *ngIf="
                        selectedSearchAtt === 'number' ||
                        selectedSearchAtt === 'expression' ||
                        selectedSearchAtt === 'long'
                      "
                    >
                      <mat-label>{{
                        "REPORTS.view.filter.value.numberPlaceholder"
                          | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="searchData['value']"
                        name="value"
                        id="value"
                        type="number"
                      />
                </mat-form-field>

                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      *ngIf="
                        selectedSearchAtt === 'date' &&
                        searchData['condition'] != 'DAY' &&
                        searchData['condition'] != 'MONTH' &&
                        searchData['condition'] != 'DAY_AND_MONTH'
                      "
                    >
                      <mat-label>{{
                        "REPORTS.view.filter.value.datePlaceholder" | translate
                      }}</mat-label>
                      <input
                        matInput
                        type="date"
                        #dateInput
                        [(ngModel)]="searchData['value']"
                        name="value"
                        id="value"
                        [placeholder]="
                          'REPORTS.view.filter.value.datePlaceholder'
                            | translate
                        "
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="dateInput.showPicker()"
                        aria-label="Open date picker"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >calendar_today</mat-icon
                        >
                  </button>
                </mat-form-field>
                  </ng-container>

                  <!-- BETWEEN Range - COMPACT DESIGN -->
                  <ng-container *ngIf="searchData['condition'] === 'BETWEEN'">
                    <div
                      class="d-flex flex-nowrap align-items-center"
                      style="flex: 1"
                    >
                      <!-- Text Range - Compact -->
                      <ng-container *ngIf="selectedSearchAtt === 'text'">
                        <mat-form-field
                          appearance="outline"
                          class=""
                          subscriptSizing="dynamic"
                          style="width: 180px"
                        >
                          <input
                            matInput
                            [(ngModel)]="searchData['rangeFrom']"
                            placeholder="Enter From value"
                            type="text"
                          />
                        </mat-form-field>
                        <mat-form-field
                          appearance="outline"
                          class=""
                          subscriptSizing="dynamic"
                          style="width: 180px"
                        >
                          <input
                            matInput
                            [(ngModel)]="searchData['rangeTo']"
                            placeholder="Enter To value"
                            type="text"
                          />
                        </mat-form-field>
                      </ng-container>

                      <!-- Number Range - Compact -->
                      <ng-container
                        *ngIf="
                          selectedSearchAtt === 'number' ||
                          selectedSearchAtt === 'expression' ||
                          selectedSearchAtt === 'long'
                        "
                      >
                        <mat-form-field
                          appearance="outline"
                          class=""
                          subscriptSizing="dynamic"
                          style="width: 180px"
                        >
                          <input
                            matInput
                            [(ngModel)]="searchData['rangeFrom']"
                            placeholder="From"
                            type="number"
                          />
                        </mat-form-field>
                        <span class="text-muted mx-0">-</span>
                        <mat-form-field
                          appearance="outline"
                          class=""
                          subscriptSizing="dynamic"
                          style="width: 180px"
                        >
                          <input
                            matInput
                            [(ngModel)]="searchData['rangeTo']"
                            placeholder="To"
                            type="number"
                          />
                        </mat-form-field>
                      </ng-container>

                      <!-- Date Range -->
                      <input
                        *ngIf="selectedSearchAtt === 'date'"
                        type="text"
                        class="form-control form-control-sm"
                        ngxDaterangepickerMd
                        [(ngModel)]="searchData['rangeDate']"
                        [showCustomRangeLabel]="true"
                        [alwaysShowCalendars]="true"
                        [ranges]="ranges"
                        [showDropdowns]="true"
                        [linkedCalendars]="true"
                        placeholder="Range"
                        style="width: 180px"
                      />
              </div>
                  </ng-container>

                  <button
                    mat-icon-button
                    matTooltip="{{
                      'REPORTS.view.filter.infoTooltip' | translate
                    }}"
                    matTooltipPosition="above"
                    class="icon-center icon-clean"
                    aria-label="Value information"
                    *ngIf="selectedSearchAtt"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
              </button>
                </ng-container>
              </div>
            </div>
          </div>

          <!--Here value is ended -->
          <div class="col-auto pe-1 mb-2">
            <button
              mat-stroked-button
              color="primary"
              [disabled]="
                !searchData['value'] &&
                !searchData['condition'] &&
                !searchData['field']
              "
              (click)="addSearchData()"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-1">add</mat-icon>
              {{ "REPORTS.view.filter.buttons.add" | translate }}
            </button>
          </div>

          <div class="col-auto pe-1 mb-2 pdf-exclude">
            <button
              mat-stroked-button
              color="primary"
              (click)="searchAndDrawnew(true)"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-1">search</mat-icon>
              {{ "REPORTS.view.filter.buttons.search" | translate }}
            </button>
          </div>

          <div class="col-auto pe-1 mb-2 pdf-exclude">
            <button
              mat-stroked-button
              color="primary"
              (click)="resetSearchCriteria()"
              class="d-flex align-items-center"
            >
              <i class="fa fa-eraser"></i>
              <span class="ms-2">{{
                "REPORTS.view.filter.buttons.clear" | translate
              }}</span>
            </button>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-12 mb-2">
            <div class="d-flex flex-wrap gap-2 px-1">
              <mat-chip
                *ngFor="let e of searchList; let i = index"
                class="filter-chip"
              >
                {{ e.label }} {{ e.condition }} {{ e.value }} {{ e.rangeFrom }}
                {{ e.rangeTo }}
                <button
                  matChipRemove
                  aria-label="Remove filter"
                  (click)="removeSearchData(i)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-chip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card-body">
        <div class="d-flex align-items-center mb-2">
        <h6>{{reportTitle}}</h6>

          <button
            *ngIf="showEditButton"
            mat-stroked-button
            color="primary"
            class="d-flex align-items-center gap-1 ms-auto"
            [routerLink]="['/uiformpivot/' + uiformid + '/' + reportId]"
            [matTooltip]="'COMMON.EDIT' | translate"
            matTooltipPosition="above"
            aria-label="Edit Report"
          >
            <mat-icon>edit</mat-icon>
            <span>{{ "COMMON.EDIT" | translate }}</span>
          </button>
        </div>

        <div class="mt-3">
          <div class="table-responsive">
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="success"
                showAlert="true"
              />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="danger"
                showAlert="true"
              />
            </p>
            <div *ngIf="loading">
              {{ "REPORTS.view.table.loading" | translate }}
            </div>
            <div *ngIf="!loading">
              <!-- <div [innerHTML]="pivottable"></div>
              <img [src]="pivotUrl" width="100%" /> -->
              <!-- ✅ Table -->
              <!-- <div *ngIf="pivottable" [innerHTML]="pivottable" class="table-responsive sticky-bordered-table">
              </div> -->
              <!-- ✅ Pivot Table - Sirf tab dikhao jab valid HTML table ho -->
              <div *ngIf="pivottable && pivottable.includes('<table')" [innerHTML]="pivottable"
                class="table-responsive sticky-bordered-table">
              </div>

              <!-- ✅ Plotly Chart -->
              <iframe #chartIframe *ngIf="chartUrl" [src]="chartUrl" width="100%" height="600px" style="border: none;">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
